import { render, staticRenderFns } from "./vcSelectConceptService.vue?vue&type=template&id=3aa11fd2&"
import script from "./vcSelectConceptService.vue?vue&type=script&lang=js&"
export * from "./vcSelectConceptService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports